module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "modal-demo",
    attrs: {
      "title": "Modal"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "type",
      "description": "类型",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("Center Modal")]), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.top_show = true
      }
    }
  }, [_vm._v("Top Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'top'
    },
    model: {
      value: (_vm.top_show),
      callback: function($$v) {
        _vm.top_show = $$v
      },
      expression: "top_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.bottom_show = true
      }
    }
  }, [_vm._v("Bottom Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'bottom'
    },
    model: {
      value: (_vm.bottom_show),
      callback: function($$v) {
        _vm.bottom_show = $$v
      },
      expression: "bottom_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.left_show = true
      }
    }
  }, [_vm._v("Left Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'left'
    },
    model: {
      value: (_vm.left_show),
      callback: function($$v) {
        _vm.left_show = $$v
      },
      expression: "left_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.right_show = true
      }
    }
  }, [_vm._v("Right Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'right'
    },
    model: {
      value: (_vm.right_show),
      callback: function($$v) {
        _vm.right_show = $$v
      },
      expression: "right_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "mask_close",
      "description": "点击遮罩层不关闭",
      "code": _vm.mask_close_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.mask_cloe_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask_close": false
    },
    model: {
      value: (_vm.mask_cloe_show),
      callback: function($$v) {
        _vm.mask_cloe_show = $$v
      },
      expression: "mask_cloe_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "mask_close",
      "description": "不显示遮罩层",
      "code": _vm.mask_show_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.mask_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "use_mask": false
    },
    model: {
      value: (_vm.mask_show),
      callback: function($$v) {
        _vm.mask_show = $$v
      },
      expression: "mask_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "prevent_scroll",
      "description": "不禁止滚动",
      "code": _vm.prevent_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.prevent_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "prevent_scroll": false
    },
    model: {
      value: (_vm.prevent_show),
      callback: function($$v) {
        _vm.prevent_show = $$v
      },
      expression: "prevent_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a936eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Modal.vue
// module id = 661
// module chunks = 0